import { Directive, Input, ElementRef, Renderer2, HostListener } from '@angular/core';
import { Sort } from './sort';

@Directive({
    selector: '[appSort]'
})
export class SortDirective {

    @Input() appSort: Array<any>;
    constructor(private renderer: Renderer2, private targetElem: ElementRef) {}

    @HostListener('click')
    sortData() {
        // CREA EL OBJETO PARA EMPEZAR A ORDENAR
        const sort = new Sort();

        // OBTIENE LA REFERENCIA DE LA COLUMNA POR LA QUE SE QUIERE ORDENAR
        const elem = this.targetElem.nativeElement;

        // OBTIENE EL ORDEN POR EL QUE SE QUIERE ORDENAR
        const order = elem.getAttribute('data-order');

        // OBTIENE EL TIPO DE LA COLUMNA POR LA QUE SE QUIERE ORDENAR
        const type = elem.getAttribute('data-type');

        // OBITIENE EL NOMBRE DE LA PROPRIEDAD DE LOS OBJETOS A ORDENAR
        const property = elem.getAttribute('data-name');

        if (order === 'desc') {
            this.appSort.sort(sort.startSort(property, order, type));
            elem.setAttribute('data-order', 'asc');
        } else {
            this.appSort.sort(sort.startSort(property, order, type));
            elem.setAttribute('data-order', 'desc');
        }
    }
}